<template>
  <div :class="`${$style.sign} ${hiddenTitle ? $style.hiddenTitle : ''}`">
    <header>
      <div @click="closePage">
        <i class="iconfont yw-xiangzuo"></i>
        <span>签到活动</span>
      </div>
      <span @click="ruleVisible = true">规则</span>
    </header>
    <div :class="$style.signArea">
      <div :class="$style.back"></div>
      <div :class="$style.info">
        <span :class="`${$style.state} ${actData.currentSignInDays == 0 ? '' : $style.active}`">{{ actData.currentSignInDays == 0 ? '今日还未签到' : '今日已签到' }}</span>
        <p :class="`${$style.label} ${(actData.signInActivityVo && actData.signInActivityVo.activityType == 1) ? $style.hidden : ''}`">活动时间：</p>
        <p :class="`${$style.time} ${(actData.signInActivityVo && actData.signInActivityVo.activityType == 1) ? $style.hidden : ''}`">{{ `${handleTime(actData.signInActivityVo.startTime) || ''}~${handleTime(actData.signInActivityVo.endTime) || ''}` }}</p>
        <div :class="$style.gameInfo" v-if="actData.signInRoleInfoVo">
          <img :src="actData.signInRoleInfoVo.gameIcon" alt="" />
          <div>
            <p>
              <span>游戏:</span><span>{{ actData.signInRoleInfoVo.gameName }}</span>
            </p>
            <p>
              <span>账号:</span><span>{{ userInfo ? userInfo.username : '' }}</span>
            </p>
          </div>
          <div>
            <p>
              <span>区服:</span><span>{{ actData.signInRoleInfoVo.serverName }}</span>
            </p>
            <p>
              <span>角色:</span><span>{{ actData.signInRoleInfoVo.roleName }}</span>
            </p>
          </div>
        </div>
        <div v-else :class="$style.noRoleInfo">
          暂无角色信息
        </div>
      </div>
      <div v-if="actData.currentSignInDays == 0" :class="$style.signBtn" @click="handleSign">
        <p>立即签到</p>
      </div>
      <div :class="$style.signSuccessBtn" v-else>
        <p>已签到{{ actData.signInDays }}天</p>
        <img :src="`${cdnLink}/box_sign/success.png`" />
      </div>
    </div>
    <div :class="$style.singleDay" v-if="actData.singleVos.length">
      <h1>单天签到奖励</h1>
      <ul>
        <li v-for="item in actData.singleVos" :key="item.rewardId" :class="!able(item) ? $style.disable : ''" @click="showGift(item)">
          <div :class="$style.status">
            <span>第{{ item.days }}天</span>
            <span :class="item.drawStatus == 1 ? $style.hasReceive : ''">{{ item.drawStatus == 1 ? '已领取' : '未领取' }}</span>
          </div>
          <div :class="[$style.content, item.rewardType == 1 ? $style.isCharge : '']">
            <img :class="item.rewardType == 1 ? $style.isCharge : ''" :src="item.rewardType == 1 ? `${cdnLink}/box_sign/charge.png` : `${cdnLink}/box_sign/giftIcon.png`" alt="" />
            <div :class="$style.desc">
              <p :class="$style.content" v-html="item.showContent ? item.showContent.replace(/(\r\n|\n|\r)/gm, '<br />') : ''"></p>
              <p :class="$style.btn" v-if="item.rewardType == 0 && able(item)">点击查看礼包码</p>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <div :class="$style.cumulativeDay" v-if="actData.cumulativeVos.length">
      <h1>累计签到奖励</h1>
      <ul>
        <li v-for="item in actData.cumulativeVos" :key="item.rewardId" :class="!able(item, 1) ? $style.disable : ''" @click="showGift(item, 1)">
          <div :class="$style.status">
            <span>累签{{ item.days }}天</span>
            <span :class="item.drawStatus == 1 ? $style.hasReceive : ''">{{ item.drawStatus == 1 ? '已领取' : '未领取' }}</span>
          </div>
          <div :class="[$style.content, item.rewardType == 1 ? $style.isCharge : '']">
            <img :class="item.rewardType == 1 ? $style.isCharge : ''" :src="item.rewardType == 1 ? `${cdnLink}/box_sign/charge.png` : `${cdnLink}/box_sign/giftIcon.png`" alt="" />
            <div :class="$style.desc">
              <p :class="$style.content" v-html="item.showContent ? item.showContent.replace(/(\r\n|\n|\r)/gm, '<br />') : ''"></p>
              <p :class="$style.btn" v-if="item.rewardType == 0 && able(item, 1)">点击查看礼包码</p>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <div :class="$style.extend" v-if="actData.signInActivityVo.introduce && actData.signInActivityVo.introduce.replace(/<p><br><\/p>/g, '')">
      <h1>额外奖励攻略</h1>
      <div v-html="actData.signInActivityVo.introduce" :class="$style.introduce"></div>
    </div>
    <!-- 绑定角色弹窗 -->
    <transition name="fade">
      <div :class="$style.selectMask" v-if="selectVisible">
        <div :class="$style.selectContent">
          <h1>绑定角色信息</h1>
          <img :src="`${cdnLink}/box_sign/close.png`" alt="" :class="$style.close" @click="selectVisible = false" />
          <p :class="$style.hint"><span>温馨提示：</span>角色信息绑定成功后，将无法解除绑定，也无法更换绑定</p>
          <div :class="$style.content">
            <p>账号:</p>
            <Field disabled v-model.trim="roleForm.account" :class="$style.field" @blur="handleInputBlur" @change="handleAccountChange"></Field>
          </div>
          <CSelect label="游戏名：" :options="gameList" :value="roleForm.appkey" @change="selectGame"></CSelect>
          <CSelect label="区服：" :options="serverList" :value="roleForm.serverId" @change="selectServer"></CSelect>
          <CSelect label="角色：" :options="roleList" :value="roleForm.roleId" @change="selectRole"></CSelect>
          <Button :class="$style.nextStep" @click="bindRole">绑定</Button>
        </div>
      </div>
    </transition>
    <!-- 礼包弹窗 -->
    <transition name="fade">
      <div :class="$style.selectMask" v-show="giftVisible">
        <div :class="$style.selectContent">
          <h1>礼包内容</h1>
          <img :src="`${cdnLink}/box_sign/close.png`" alt="" :class="$style.close" @click="giftVisible = false" />
          <p v-html="giftDesc.replace(/(\r\n|\n|\r)/gm, '<br />')" :class="$style.giftDesc" v-show="!rewardType"></p>
          <div :class="$style.giftInput" v-show="!rewardType"><span>礼包码：</span>{{ cdk }}</div>
          <Button :class="`${$style.nextStep} copy-btn`" :data-clipboard-text="cdk" v-show="!rewardType">复制礼包码</Button>
          <p v-show="rewardType" :class="$style.awardTip">请耐心等待，我们将会在五个工作日内通过邮件发放到绑定角色中，届时请注意查收哦~</p>
          <Button :class="$style.nextStep" @click="giftVisible = false" v-show="rewardType">确认</Button>
        </div>
      </div>
    </transition>
    <!-- 规则说明 -->
    <transition name="fade">
      <div :class="$style.selectMask" v-show="ruleVisible">
        <div :class="$style.selectContent">
          <h1>规则说明</h1>
          <img :src="`${cdnLink}/box_sign/close.png`" alt="" :class="$style.close" @click="ruleVisible = false" />
          <p :class="$style.rule" v-html="this.actData.signInActivityVo.ruleExplain ? this.actData.signInActivityVo.ruleExplain.replace(/(\r\n|\n|\r)/gm, '<br />') : ''"></p>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { inithandler } from '@/bridge/jsBridge';
import { CDN_URL_1 } from '@/config';
import { signInEventTrack, getUserInfo, toLogin, onGoBack, setPageTitle, setPageTitleColor, setPageTitleBgColor, setRightTxt, clickRightTxt } from '@/bridge/AppJsBridge';
import { eventTrackApi, getGameList, getServerList, bindRole, signIn, getActList, drawGift } from '@/apis/box';
import CSelect from '@/components/Select';
import { Button, Field } from 'vant';
import Clipboard from 'clipboard';
import { versionCompare } from '@/libs/utils'

export default {
  name: '',
  data() {
    return {
      cdnLink: CDN_URL_1,
      userInfo: '',
      deviceInfo: {}, // 客户端传过来的信息
      actData: {
        currentSignInDays: 0,
        signInDays: 0,
        signInActivityVo: {},
        signInRoleInfoVo: null,
        singleVos: [],
        cumulativeVos: []
      },
      selectVisible: false,
      roleForm: {
        account: '',
        appkey: '',
        appName: '',
        serverName: '',
        serverId: '',
        roleName: '',
        roleId: '',
        gameIcon: ''
      },
      giftDesc: '',
      cdk: '',
      rewardType: 0,
      gameList: [],
      serverList: [],
      roleAllList: [],
      roleList: [],
      giftVisible: false,
      ruleVisible: false,
      actId: '',
      version: '',
      hiddenTitle: false,
    };
  },
  created() {
    this.actId = this.$route.query.actId || '';
    this.version = this.$route.query.version || '';
    if (versionCompare(this.version, '1.2.0')) {
      this.hiddenTitle = true;
    }
    inithandler();
    this.bridgeListener();

    setPageTitle('签到活动');
    setPageTitleColor('#FFFFFF');
    setPageTitleBgColor('#FFC24B');
    setRightTxt('规则');
  },
  mounted() {
    this.copyInit();
  },
  components: {
    CSelect,
    Button,
    Field
  },
  methods: {
    /**
     * 判断是否置灰 true 否 false 是
     * @param award 当前奖励信息
     * @param type 0.单日 1.累计
     */
    able(award, type) {
      if (!type) {
        return this.actData.currentSignInDays === award.days || award.drawStatus == 1;
      } else {
        return award.days <= this.actData.signInDays;
      }
    },
    bridgeListener() {
      signInEventTrack(data => {
        this.deviceInfo = JSON.parse(data);
      });
      getUserInfo(userInfo => {
        this.userInfo = JSON.parse(userInfo);
        localStorage.setItem('token', this.userInfo.token || '');
        this.roleForm.account = this.userInfo.username;
        this.getActList(1);
        this.getGameList();
      });
      clickRightTxt(() => {
        this.ruleVisible = true
      })
    },
    async handleSign() {
      if (!this.userInfo.token) {
        toLogin('/loginKey/LoginByKeyPhoneActivity');
        return;
      }
      if (!this.actData.signInRoleInfoVo) {
        this.selectVisible = true;
        return;
      }
      const form = new FormData();
      form.append('activityId', this.actId);
      await signIn(form);
      this.getActList();
      this.eventTrack('SIGN_IN');
      this.$toast('签到成功');
    },
    closePage() {
      onGoBack();
    },
    eventTrack(event) {
      eventTrackApi({
        ...this.deviceInfo,
        event,
        activeName: this.actData.signInActivityVo.activityName,
        actId: 'null',
        appkey: 'null',
        userId: this.userInfo.uid
      });
    },
    copyInit() {
      this.copy = new Clipboard('.copy-btn');
      this.copy.on('success', e => {
        this.$toast('礼包码复制成功，请进入游戏兑换');
      });
    },
    handleAccountChange() {},
    async getGameList() {
      const r = await getGameList();
      this.gameList = r.data.map(item => {
        return {
          ...item,
          text: item.appName,
          value: item.appkey
        };
      });
    },
    async selectGame(data) {
      this.roleForm = {
        ...this.roleForm,
        appkey: data.appkey,
        appName: data.appName,
        gameIcon: data.gameIcon
      };
      const form = new FormData();
      form.append('appkey', data.appkey);
      const r = await getServerList(form);
      this.roleAllList = r.data;
      const res = new Map();
      this.serverList = r.data.filter(item => !res.has(item['serverId']) && res.set(item['serverId'], 1));
      this.serverList = this.serverList.map(item => {
        return {
          ...item,
          text: item.serverName,
          value: item.serverId
        };
      });
      this.roleForm.serverId = '';
      this.roleForm.serverName = '';
      this.roleForm.roleName = '';
      this.roleForm.roleId = '';
    },
    selectServer(data) {
      this.roleForm.serverId = data.serverId;
      this.roleForm.serverName = data.serverName;
      this.roleList = this.roleAllList.filter(item => item.serverId === data.serverId);
      this.roleList = this.roleList.map(item => {
        return {
          ...item,
          text: item.roleName,
          value: item.roleId
        };
      });
      this.roleForm.roleName = '';
      this.roleForm.roleId = '';
    },
    selectRole(data) {
      this.roleForm.roleId = data.roleId;
      this.roleForm.roleName = data.roleName;
    },
    handleInputBlur() {},
    async bindRole() {
      await bindRole({
        activityId: this.actId,
        ...this.roleForm
      });
      this.$toast('绑定成功');
      this.selectVisible = false;
      const form = new FormData();
      form.append('activityId', this.actId);
      await signIn(form);
      this.eventTrack('SIGN_IN');
      this.getActList();
    },
    async showGift(giftItem, type) {
      if (!this.able(giftItem, type)) return;
      let r = '';
      if (giftItem.drawStatus == 2) {
        r = await drawGift({
          activityId: this.actId,
          rewardId: giftItem.rewardId
        });
        giftItem.drawStatus = 1;
        giftItem.cdk = r.data.cdk;
      }
      this.rewardType = giftItem.rewardType;
      this.cdk = giftItem.cdk;
      this.giftDesc = giftItem.showContent;
      this.giftVisible = true;
    },
    async getActList(type) {
      const form = new FormData();
      form.append('activityId', this.actId);
      const r = await getActList(form);
      this.actData = r.data;
      if (this.userInfo.uid && type) {
        this.eventTrack('ENTER_ACTIVE_PAGE');
      }
    },
    handleTime(time) {
      if (!time) return;
      return time.split(' ')[0] || '';
    }
  }
};
</script>

<style lang="scss">
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
<style lang="scss" module>
.sign {
  width: 100%;
  height: 100%;
  max-width: 375px;
  margin: auto;
  background: #f1f1f1;
  padding-top: 50px;
  padding-bottom: 80px;
  overflow: auto;
  &.hiddenTitle {
     padding-top: 0px;
    > header {
      display: none;
    }
  }
  > header {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    max-width: 375px;
    margin: auto;
    z-index: 1;
    background: #ffc24b;
    color: #ffffff;
    font-size: 19px;
    padding: 14px 15px 14px 5px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    > div {
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-weight: bold;
    }
    > span {
      font-size: 16px;
    }
    :global {
      .iconfont {
        font-size: 22px;
        margin-right: 5px;
      }
    }
  }
  .signArea {
    width: 100%;
    height: 250px;
    background: linear-gradient(-180deg, #ffc24b 0%, #f1f1f1 10%);
    position: relative;
    .back {
      width: 100%;
      height: 148px;
      background: url('//static.hzwxbz3.cn/Lianyun/font_end/wxhd/box_sign/signBack1.png') no-repeat;
      background-size: 100% 100%;
    }
    .info {
      position: absolute;
      background: url('//static.hzwxbz3.cn/Lianyun/font_end/wxhd/box_sign/signBack.png') no-repeat;
      background-size: 100% 100%;
      // background-color: #000000;
      width: 375px;
      height: 214px;
      left: 0;
      right: 0;
      top: 47px;
      margin: auto;
      padding: 30px 10px 0 7px;
      .state {
        display: inline-block;
        background: #00c300;
        color: #ffffff;
        padding: 4px 20px 4px 5px;
        font-size: 14px;
        border-bottom-right-radius: 20px;
        margin-bottom: 10px;
        &.active {
          background: #ff7c34;
        }
      }
      .label {
        color: #ff7c34;
        margin-left: 4px;
        font-size: 13px;
        margin-bottom: 4px;
        &.hidden {
          visibility: hidden;
        }
      }
      .time {
        color: #ff9c2f;
        font-size: 12px;
        margin-left: 4px;
        margin-bottom: 20px;
        &.hidden {
          visibility: hidden;
        }
      }
      .gameInfo {
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 14px;
        background: #fff9d9;
        border-top-right-radius: 30px;
        border-bottom-left-radius: 30px;
        width: 340px;
        height: 73px;
        margin: auto;
        > img {
          width: 50px;
          height: 50px;
          margin-right: 10px;
        }
        > div {
          width: 115px;
          margin-right: 10px;
          font-size: 12px;
          line-height: 14px;
          > p {
            width: 100%;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            color: #ffb82e;
            margin: 10px 0;
            > span:nth-child(1) {
              color: #ff931a;
            }
            > span:nth-child(2) {
              color: #ffb82e;
            }
          }
        }
      }
    }
    .noRoleInfo {
      text-align: center;
      padding-top: 20px;
      color: #b6b4b4;
    }
    .signBtn {
      position: absolute;
      background: url('//static.hzwxbz3.cn/Lianyun/font_end/wxhd/box_sign/sign.png') no-repeat;
      background-size: 100% 100%;
      width: 150px;
      height: 150px;
      top: -2px;
      right: 12px;
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      justify-content: center;
      color: #ffffff;
      font-size: 16px;
      font-weight: bold;
      &:active {
        opacity: 0.8;
      }
      > p {
        line-height: 18px;
        width: 36px;
        text-align: center;
      }
    }
    .signSuccessBtn {
      position: absolute;
      background: url('//static.hzwxbz3.cn/Lianyun/font_end/wxhd/box_sign/sign1.png') no-repeat;
      background-size: 100% 100%;
      width: 150px;
      height: 150px;
      top: -2px;
      right: 12px;
      color: #ffffff;
      font-size: 16px;
      font-weight: bold;
      padding-top: 60px;
      > p {
        line-height: 18px;
        text-align: center;
      }
      > img {
        display: block;
        width: 20px;
        margin: auto {
          top: 5px;
        }
      }
    }
  }
  .singleDay {
    width: calc(100% - 20px);
    max-width: 400px;
    margin: 0 10px {
      bottom: 10px;
    }
    border-radius: 10px;
    background: #ffffff;
    > h1 {
      background: url('//static.hzwxbz3.cn/Lianyun/font_end/wxhd/box_sign/title1.png') no-repeat;
      background-size: 100% 100%;
      height: 33px;
      width: 159px;
      line-height: 36px;
      padding-left: 30px;
      color: #666666;
      font-weight: bold;
      margin-bottom: 5px;
    }
    > ul {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      padding: 8px;
      > li {
        width: 164px;
        height: 110px;
        border-radius: 10px;
        overflow: hidden;
        margin: 5px 0;
        box-shadow: -2.08px 0px 20.49px 2.08px rgba(190, 190, 190, 0.26);
        flex: none;
        &:active {
          opacity: 0.8;
        }
        &.disable {
          filter: grayscale(100%);
          filter: gray;
        }
        .status {
          display: flex;
          justify-content: space-between;
          height: 26px;
          > span:nth-child(1) {
            width: 100px;
            font-size: 13px;
            line-height: 26px;
            font-weight: bold;
            padding-left: 5px;
            font-style: italic;
            text-align: left;
            color: #ffa842;
            background: url('//static.hzwxbz3.cn/Lianyun/font_end/wxhd/box_sign/giftBack.png?v=1') no-repeat;
            background-size: 100% 100%;
          }
          > span:nth-child(2) {
            width: 60px;
            font-size: 13px;
            line-height: 26px;
            font-weight: bold;
            text-align: center;
            color: #ffffff;
            background: #5cbb5c;
            border-bottom-left-radius: 10px;
            &.hasReceive {
              background: #ff7c34;
            }
          }
        }
        > .content {
          width: 156px;
          height: 64px;
          background: url('//static.hzwxbz3.cn/Lianyun/font_end/wxhd/box_sign/giftBack1.png?v=1') no-repeat;
          background-size: 100% 100%;
          margin: auto {
            top: 10px;
          }
          display: flex;
          align-items: center;
          &.isCharge {
            background-image: url('//static.hzwxbz3.cn/Lianyun/font_end/wxhd/box_sign/giftBack2.png?v=1');
          }
          > img {
            display: inline-block;
            margin-left: 5px;
            margin-right: 10px;
            margin-top: -10px;
            width: 50px;
            height: 48px;
            &.isCharge {
              margin-top: 4px;
            }
          }
          .desc {
            font-size: 10px;
            color: #ffa842;
            line-height: 12px;
            .btn {
              color: #00c300;
              font-weight: 700;
            }
          }
        }
      }
    }
  }
  .cumulativeDay {
    @extend .singleDay;
    > h1 {
      background-image: url('//static.hzwxbz3.cn/Lianyun/font_end/wxhd/box_sign/title3.png');
    }
  }
  .extend {
    width: calc(100% - 20px);
    max-width: 400px;
    margin: 0 10px;
    border-radius: 10px;
    background: #ffffff;
    padding-bottom: 40px;
    > h1 {
      background: url('//static.hzwxbz3.cn/Lianyun/font_end/wxhd/box_sign/title2.png') no-repeat;
      background-size: 100% 100%;
      height: 33px;
      width: 159px;
      line-height: 36px;
      padding-left: 30px;
      color: #666666;
      font-weight: bold;
      margin-bottom: 5px;
    }
  }
  .introduce {
    margin: 10px;
    font-size: 12px;
    line-height: 1.2;
  }
  .selectMask {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.6);
  }
  .selectContent {
    width: 278px;
    border-radius: 8px;
    overflow: hidden;
    // overflow: hidden;
    background: #ffffff;
    position: absolute;
    top: 50%;
    left: 0;
    right: 0;
    transform: translateY(-50%);
    margin: auto;
    padding-bottom: 100px;
    .close {
      position: absolute;
      top: 10px;
      right: 10px;
      width: 18px;
    }
    > h1 {
      width: 100%;
      height: 41px;
      text-align: center;
      background-color: #ffb017;
      color: #ffffff;
      font-size: 17px;
      font-weight: bold;
      // border-radius: 6px;
      line-height: 41px;
    }
    .hint {
      font-size: 12.5px;
      color: #999999;
      margin: 11px 20px;
      line-height: 15px;
      > span {
        color: #666666;
      }
    }
    > .content {
      width: 225.69px;
      background: #f2f2f2;
      border-radius: 17.36px;
      display: flex;
      align-items: center;
      padding: 4px 15px;
      margin: auto;
      margin-bottom: 8px;
      > p {
        color: #cdcdcd;
        font-size: 14px;
      }
      .field {
        border: none;
        padding: 0px 8px;
        background: transparent;
        width: 140px;
        height: 26px;
        :global {
          input {
            color: #7c7c7c;
          }
        }
      }
      :global {
        .yw-select-wrap {
          width: 100%;
          background-color: #e0e0e0;
          color: #888585;
        }
      }
    }
    .nextStep {
      position: absolute;
      bottom: 30px;
      left: 0;
      right: 0;
      margin: auto;
      width: 190px;
      height: 38px;
      line-height: 38px;
      border: none;
      border-radius: 38px;
      background: #ffb017;
      color: #ffffff;
    }
    .giftDesc {
      text-align: center;
      color: #ffa842;
      line-height: 20px;
      margin: 20px 0 40px;
    }
    .giftInput {
      width: 194px;
      height: 42px;
      margin: auto;
      background: #f2f2f2;
      border-radius: 20.83px;
      line-height: 42px;
      padding-left: 20px;
      > span {
        color: #999999;
      }
    }
    .awardTip {
      color: #999999;
      line-height: 25.69px;
      font-size: 15.97px;
      text-align: center;
      padding: 30px;
    }
    .rule {
      color: #999999;
      line-height: 25.69px;
      font-size: 13.97px;
      text-align: left;
      padding: 15px;
    }
  }
}
</style>
